import { render } from "./GlobalConfigPage.vue?vue&type=template&id=2416eb3a&scoped=true&ts=true"
import script from "./GlobalConfigPage.vue?vue&type=script&lang=ts"
export * from "./GlobalConfigPage.vue?vue&type=script&lang=ts"

import "./GlobalConfigPage.vue?vue&type=style&index=0&id=2416eb3a&lang=scss&scoped=true"

import exportComponent from "/home/nathan/public_html/accident-plan/accident-plan-api-whitelabel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2416eb3a"]])

export default __exports__